<template>
  <div class="Core">
    <Menu></Menu>
    <router-view></router-view>
    <Cookie></Cookie>
    <Footer></Footer>
  </div>
</template>

<script>

/*
 * * * * * * * * * *
 *
 *   FONT
 *
 * * * * * * * * * *
 */

import '@bbx/font~master/core/env/browser/css/gotham/GothamBook.css'
import '@bbx/font~master/core/env/browser/css/gotham/GothamBold.css'
import '@bbx/font~master/core/env/browser/css/omnes/OmnesRegular.css'

import {eventService} from "../service/eventService";
import {ListenerTrigger} from "@bbx/listener~master/core/delta/ListenerTrigger";
import {EVENT} from "../constant/EVENT";

export default {
  mounted() {
    setTimeout(() => eventService.triggerByName(new ListenerTrigger({
      name: EVENT.START_ANIMATION,
    })))
  }
}
</script>

<style>


/*
 * * * * * * * * * *
 *
 *   GLOBAL
 *
 * * * * * * * * * *
 */

body {
  margin: 0;
  color: #000000;
  background: white;
  font-family: OmnesRegular, sans-serif;
  font-size: 16px;
  scroll-behavior: smooth;
}


/*
 * * * * * * * * * *
 *
 *   COLOR
 *
 * * * * * * * * * *
 */

:root {
  --colorPrimary: #00AEB0;
  --colorPrimaryAlpha5: rgba(0, 174, 176, 0.05);
  --colorDarker: #00919B;
  --colorLigher: #2cbec4;
}

/*
 * * * * * * * * * *
 *
 *   OVERIDE
 *
 * * * * * * * * * *
 */

.Text {
  font-size: 14px;
  margin-bottom: 20px;
}

.Text,
.Paragraph {
  line-height: 28px;
  word-spacing: 1px;
}

.Text strong,
.Text ul li,
.Text a {
  font-size: 14px;
  color: black;
}

.Text ul {
  list-style-image: url("/img/global/dot.svg");
}

.Text ul li{
  margin: 10px 0;
}

.Justify {
  text-align: justify;
}
</style>